module.exports = __webpack_public_path__ + "ebdafb4dfb8f0366cc322fdf8a279d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-hai.png
// module id = 2029
// module chunks = 4